import { BLUE, RED } from '../HOME/const';
import { TM_ORANGE } from './const';
import { dbget, dbdel, dbset } from '../HOME/utils';

export function levelInfo(level) {
  if (!level) {
    return {};
  }

  switch (level.toString()) {
    default:
    case '1':
      return { name: 'BASIC', time: 0, color: 'green' };
    case '2':
      return { name: 'MASTER', time: 10, color: BLUE };
    case '3':
      return { name: 'SUPERHERO', time: 8, color: RED };
    case '4':
      return { name: 'ETERNAL', time: 5, color: TM_ORANGE };
  }
}

export function canSurrender(props) {
  const board = props.board.current ? props.board.current : null;
  return board && !board.blocked() && props.steps > 0;
}

const baseKey = props => {
  const { size } = props;
  return `TM • ${size} • `;
};

export function boardKey(props) {
  return `${baseKey(props)}BOARD`;
}

export function statsKey(props) {
  return `${baseKey(props)}STATS`;
}

export function levelsCompletedKey(props) {
  return `${baseKey(props)}LEVELS COMPLETED`;
}

export function getStats(props, resolve) {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
}

export function setStats(props) {
  dbdel(boardKey(props));

  let { score, stats } = props;
  let { plays, aggScore, bestScore } = stats || {};

  plays = (plays || 0) + 1;
  aggScore = (aggScore || 0) + score;
  bestScore = Math.max(score, bestScore || 0);

  const key = statsKey(props);
  stats = { plays, aggScore, bestScore };

  dbset(key, stats);
  props.updateStats(stats);
}
